import { patch } from '../api';

const patchEmployerLandingPage = async (employerId, data) => {
  return await patch(`/public_landing_pages/${employerId}`, data);
};

export default patchEmployerLandingPage;
